import { selectIsInsufficientFunds } from '../../../../shared/ServicePickerWidget/selectors/checkoutInfo';
import { selectServiceUnavailableReason } from '../../../../shared/ServicePickerWidget/selectors/publishTerms';
import {
  selectRecommendedDepositAmount,
  selectIsSubagentMasterAccountMoneyLimitExceeded,
} from '../../../../shared/ServicePickerWidget/selectors/balance';
import { EUnavailableReason } from '../../../../shared/ServicePickerWidget';
import { IExtendedContext } from '../../../types/extendedContext';
import { openPaymentModalThunk } from '../../../../shared/ServicePickerWidget/thunks/payment/openPaymentModal';
import { EPaymentStatus, EPaymentType } from '../../../../shared/ServicePickerWidget/types/reducers/paymentProcessing';
import { checkServiceThunk } from '../../../../shared/ServicePickerWidget/thunks/checkout/checkService';
import { selectShouldPayByCard } from '../../../../shared/ServicePickerWidget/selectors/publishAvailable';
import { setIsSubagentNotEnoughMoney } from '../../../../shared/ServicePickerWidget/actions/publishInfo';
import { selectPlacingMoneySource } from '../../../../shared/ServicePickerWidget/reducers/v2/moneySources/selectors';
import { selectIsSubagent } from '../../../../shared/ServicePickerWidget/reducers/v2/user/selectors';
import { EMoneySource } from '../../../../shared/ServicePickerWidget/types/reducers/user';
import { createAnalytics } from '../../../../shared/AppModulesWrapper';

export const checkPublishAvailabilityHandler = (context: IExtendedContext) => async (): Promise<boolean> => {
  const { store, config, logger } = context;

  const analytics = createAnalytics({ getState: store.getState, logger });

  const state = store.getState();

  const shouldSwitchToSelf = selectIsSubagentMasterAccountMoneyLimitExceeded(state);
  const shouldPayByCard = selectShouldPayByCard(state);
  const isSubagent = selectIsSubagent(state);
  const placingMoneySource = selectPlacingMoneySource(state);
  const isInsufficientFunds = selectIsInsufficientFunds(state);
  const recommendedDepositAmount = selectRecommendedDepositAmount(state);
  const unavailableReason = selectServiceUnavailableReason(state);

  // Проверяем, что необходимо переключиться на личный счёт для суба
  if (shouldSwitchToSelf) {
    store.dispatch(setIsSubagentNotEnoughMoney(true));

    return false;
  }

  // В случае суба в инфе пользака признак доступности оплаты картой будет false, поэтому вычисляем свой признак
  const shouldSubagentPayByCard = isInsufficientFunds && isSubagent && placingMoneySource === EMoneySource.Self;

  // Проверяем, что нам нужно оплатить картой
  if (shouldSubagentPayByCard || shouldPayByCard) {
    analytics.send({ action: 'not_enough_money_popup_open', label: 'add_offer' });

    const paymentResult = await store.dispatch(
      openPaymentModalThunk({ amount: recommendedDepositAmount, type: EPaymentType.Publish }),
    );

    if (paymentResult === EPaymentStatus.Canceled) {
      return false;
    }

    await store.dispatch(checkServiceThunk());

    const retryResult = await checkPublishAvailabilityHandler(context)();

    return retryResult;
  }

  // Если все предыдущие ветки не прошли, но нам всё ещё не хватает средств (юрлица)
  // то редиректим в ЛК в раздел кошелька
  if (isInsufficientFunds) {
    const lkSpecialistBaseUrl = config.get<string>('lkSpecialist.baseUrl');

    window.open(`${lkSpecialistBaseUrl}/pay`, '_blank');

    return false;
  }

  // Отдельный костыль, пока не будет убита старая ФП (в новой без фото в принципе невозможно пройти на следующий шаг),
  // где можно разместиться без фото, в новой ФП на шаге ФВУ недоступна валидация фотографий, поэтому делается тут
  if (unavailableReason === EUnavailableReason.NoPhotos) {
    context.appEvent.onPublicationUnavailableReasonChange(EUnavailableReason.NoPhotos);

    return false;
  }

  return true;
};
